import { filter, mergeMap } from 'rxjs/operators';

import { RootEpic } from '../../../store/epics';
import { loadAnalyticsData, loadAnalyticsDataFail, loadAnalyticsDataSuccess } from '../reducers/analytics-data';

const loadAnalyticsDataEpic: RootEpic = (action$, _state$, { api: { qualification } }) =>
  action$.pipe(
    filter(loadAnalyticsData.match),
    mergeMap(() => qualification.getAnalyticsData().then(loadAnalyticsDataSuccess).catch(loadAnalyticsDataFail)),
  );

export { loadAnalyticsDataEpic };
